import { makeAutoObservable } from "mobx";

import { PermissionBit } from "../../api";
import {
  readAssignedOnly,
  writeAssignedOnly,
} from "../../components/assigned-only-toggle";
import { PatientsTabModel, TabDef } from "./patients-tab-model";

export class PatientsTabs {
  activeTabId: string;
  assignedOnly: boolean;
  readonly tabs: Map<string, PatientsTabModel>;
  readonly visibleDefs: TabDef[];

  constructor(
    permissions: PermissionBit[],
    userUUID: string,
    visibleDefs: TabDef[],
    initialTabId?: string,
  ) {
    makeAutoObservable(this);
    this.visibleDefs = visibleDefs;
    this.assignedOnly = readAssignedOnly("patients");
    this.tabs = new Map(
      visibleDefs.map((def) => [
        def.id,
        new PatientsTabModel(
          def,
          () => this.assignedOnly,
          permissions,
          userUUID,
        ),
      ]),
    );
    const fallback = visibleDefs[0]?.id ?? "active";
    this.activeTabId =
      initialTabId && visibleDefs.some((d) => d.id === initialTabId)
        ? initialTabId
        : fallback;
  }

  get activeTab() {
    return this.tabs.get(this.activeTabId);
  }

  async setTab(tabId: string) {
    this.activeTabId = tabId;
    await this.activeTab?.loadIfNeeded();
  }

  async loadActiveTab() {
    await this.activeTab?.loadIfNeeded();
  }

  async setAssignedOnly(value: boolean) {
    if (this.assignedOnly === value) return;
    this.assignedOnly = value;
    writeAssignedOnly("patients", value);
    for (const tab of this.tabs.values()) {
      tab.invalidate();
    }
    await this.activeTab?.loadIfNeeded();
  }
}
